document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.mlb-add-to-cart-form').forEach((form) => {

    form.addEventListener('submit', async (e) => {
      e.preventDefault();

      const button = form.querySelector('button[type="submit"]');
      const text = button.querySelector('span');

      button.disabled = true;

      if (text) {
        text.textContent = 'ADDING...';
      }

      try {
        const formData = new FormData(form);

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Accept': 'application/json'
          },
          body: formData
        });

        if (!response.ok) {
          throw new Error('Unable to add product');
        }

        await response.json();

        if (text) {
          text.textContent = 'ADDED ✓';
        }

        /*
         * Apply WELCOME50 coupon
         * and go directly to cart page.
         */
        window.location.href = '/discount/WELCOME50?redirect=/cart&welcome50=1&utm_source=qr&utm_medium=print&utm_campaign=mlb-season&utm_content=print-ad';

      } catch (error) {

        console.error('Add to cart error:', error);

        if (text) {
          text.textContent = 'ERROR';
        }

        button.disabled = false;

        setTimeout(() => {
          if (text) {
            text.textContent = 'ADD TO CART';
          }
        }, 1500);
      }
    });

  });
});